import { Device } from '@bcf-shared-settings/settings/types';
import { deviceBase } from 'configs/device/sportsbook/mobile-twa/device.base';

export const device: Device = {
  ...deviceBase
};
